import React from 'react';
import '../CSS/AttendanceDetails.css';
import Flatlist from 'flatlist-react';
import {useHistory} from 'react-router-dom';
import Model from '../Components/Attendance/ModelDetails';
import LeftArrow from '../Images/leftArrow.png';
import Refresh from '../Images/refresh.png';
import {Card} from '@material-ui/core';
import { motion} from 'framer-motion';
import Loading from '../Components/Loading';
import { pageTransition, pageStyle, pageVariants } from '../Components/Animations/Transition';
import {getUrl} from '../Functions.js';

function AttendanceDetails(props){
  const history  = useHistory();
  if(localStorage.getItem("loggedIn")!=="true"){
    history.push("/opening");
  }

  const id = localStorage.getItem("id");
  const name = localStorage.getItem("name");
  const cookie = localStorage.getItem("cookie");
  
  const [loading, setLoading] = React.useState(true);
  const [attendance, setAttendance] = React.useState([]);
  const [total, setTotal] = React.useState({});

  var update = false;
  var loadingHeight="78vh";

  const options = {
    method : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      cookies:cookie,
      id:id
    })
  }

  function back(){
    history.push("/Attendance");
  }

  function fetchData(){
    if(localStorage.getItem("loggedIn")!=="true"){
      history.push("/opening");
    }
    setAttendance([])
    setLoading(true);
    fetch(getUrl() + 'attendanceDetails', options)
      .then(response => response.json()).then(
        data =>{
          if(data.retry===true){
            console.log("retrying...");
            fetchData();
          }else{
              setTotal(data.attendanceDetails.pop());
              setAttendance(data.attendanceDetails);
              setLoading(false);
              update = false;
          }
        }
      );

  }
  
React.useEffect(() => {
    fetchData();
  },[]);

  return(
      <motion.div className="AttedanceDetails"
        initial="initial"
        animate="in"
        exit="out"
        style={pageStyle}
        variants={pageVariants}
        transition={pageTransition}>
        <div className="TopAttedanceDetails">
            <img src={LeftArrow} alt="back" className="BackAttedanceDetails" onClick={()=>{
              back();
            }} color="#000000" />
            <div className="Name">{name}</div>
            <img src={Refresh} alt="refresh" className="RefreshAttedanceDetails" onClick={()=>{
              if(update!==true){
                update = true;
                fetchData();
              }}} color="#000000"/>
          </div>

          {loading===true?<Loading height={loadingHeight} color="#ffffff"/>:
          <div className="FlatlistAttedanceDetails">
          <Flatlist
            list={attendance}
            renderItem={(item,index)=>
            <Model item={item} index={index}/> 
            }
            renderWhenEmpty={() =><div></div>}
            renderOnScroll
            />
            <Card
              raised
              className="CardDetailsAttedanceDetails"
              style={{
                  borderRadius:"5px",
              }}>

              <div
                className="Box1AttedanceDetails">
                    <div
                    className="TotalTextAttedanceDetails">
                        {total.time}
                    </div>
                </div>                
                
                <div
                className="Box2AttedanceDetails">
                    <div 
                    className="PresentAttedanceDetails">
                        Present : {total.present}
                    </div>
                    
                    <div
                    className="AbsentAttedanceDetails">
                        Absent : {total.absent}
                    </div>
                </div>
            </Card>
          </div>
          }
      </motion.div>
  );
}


export default AttendanceDetails;